import axios from '../axios/redditlikeApi'

const fetchPostsByUserId = (pagination, pageSize, userId) => {
  return axios.get(`/user/${userId}/posts?page=${pagination}&size=${pageSize}`)
}

const fetchCommentsByUserId = (pagination, pageSize, userId) => {
  return axios.get(`/user/${userId}/comments?page=${pagination}&size=${pageSize}`)
}

const refreshUserToken = (userId) => {
  return axios.get(`/user/${userId}/refresh-token`)
}

export default {
  fetchPostsByUserId,
  fetchCommentsByUserId,
  refreshUserToken
}
